import DotsOptionsMenu from "components/Menus/DotsOptionsMenu";
import FieldFormatter from "components/Records/Formatters/FieldFormatter";
import InfoToolip from "elements/InfoToolip";
import { Badge, Button } from "reactstrap";
import FieldUtils from "utils/FieldUtils";

/**
 * SummaryCardToolbar - A toolbar for the SummaryCardWidget
 * @param {string} id - Any unique id
 * @param {Object} options - Options for the widget
 * @param {function} onView - Callback for when the View button is clicked
 * @param {Object} fieldSchema - The field schema for the parent record
 * @param {Object} record - The current record being viewed
 * @param {Array<records>} records - All of the records possible to view.
 * @param {Object} parentRecord - The parent record
 */
const SummaryCardToolbar = ({
  id,
  options,
  customOptions,
  fieldSchema,
  record,
  records,
  parentRecord,
  collapse,
  toggleCollapse,
  reusableViewReferenceFields,
}) => {
  const EditButton = (
    <Button disabled={fieldSchema?.ReadOnly} size="sm" outline>
      Edit
    </Button>
  );

  return (
    <div
      className="d-flex justify-content-between align-items-center py-2 pl-2 pr-2 bg-superlight"
      style={{
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        height: 50,
        outline: "2px solid var(--superlight)",
      }}
    >
      <div
        style={{ fontSize: 14 }}
        className="font-weight-bold text-dark d-flex align-items-center"
      >
        <Button
          className="btn-icon-only mr-2"
          onClick={toggleCollapse}
          size="sm"
          outline
          style={{ width: "unset", height: "unset", padding: 3 }}
        >
          <i className={`mdi mdi-chevron-${collapse ? "right" : "down"}`}></i>
        </Button>
        {fieldSchema?.Name}
        {fieldSchema?.Description && (
          <InfoToolip
            text={fieldSchema?.Description}
            iconCSS="ml-2"
            size={18}
            styles={{ lineHeight: 1, position: "relative", top: 2 }}
          />
        )}
        {fieldSchema?.FieldType === "Subitem" && (
          <Badge className="ml-2">Subitem</Badge>
        )}
        {fieldSchema?.FieldType === "MultiSubitem" && (
          <Badge className="ml-2">Multi-Subitem</Badge>
        )}
      </div>
      <div className="d-flex align-items-center">
        <div>
          {FieldUtils.fieldTypeIsReference(fieldSchema?.FieldType) && (
            <FieldFormatter
              field={fieldSchema}
              value={
                fieldSchema?.FieldType === "SingleReference" ? record : records
              }
              record={parentRecord}
              recordID={parentRecord?.id}
              moduleAPIName={
                parentRecord?._ModuleAPIName || parentRecord?.ModuleAPIName
              }
              customDisplayComponent={EditButton}
              reusableViewReferenceFields={reusableViewReferenceFields}
            />
          )}
        </div>
        {options && !fieldSchema?.ReadOnly && (
          <DotsOptionsMenu
            id={id}
            options={options}
            dotsSize={22}
            placement="autoVerticalEnd"
          />
        )}
        {customOptions && customOptions}
      </div>
    </div>
  );
};

export default SummaryCardToolbar;
